
import {AbstractBookmarkDataProvider, API_URL_BOOKMARKS_PART} from './abstract-bookmark-data-provider';

/* ./api/json/user/1/bookmarks/1/remove*/

export default class BookmarkDeleteDataProvider extends AbstractBookmarkDataProvider {

    constructor() {
        super(); // Call the parent class constructor
    }

    public async deleteBookmark (
        userId: number,
        bookmarkId: number,
        authToken: string,
        params = {},
        headers: { [key: string | number]: string | number} = {}
    ) {

        let urlPart = userId + API_URL_BOOKMARKS_PART + '/' + bookmarkId + '/remove/';

        return await super.sendData(urlPart, authToken, params, headers);
    }

}